class ProductSubscriptions extends HTMLElement {
    connectedCallback() {
        this.formatElements = this.querySelectorAll('.format__variant-element');
        this.form = this.querySelector('.main-form');
        this.form_format = this.querySelector('.format-single-variant');
        this.oneTimeSwitch = this.form?.elements['selling_plan'];
        this.savedValue = this.querySelector('.saved-value-element .saved-value')
        this.nextBtn = this.querySelector('.next-screen-button');
        this.backBtn = this.parentNode.querySelector('.modal-back');
        const idField = this.form?.elements['id'];
        this.variants = !idField ? [] : (idField instanceof Element ? [idField] : Array.from(idField));
        this.variantImages = Array.from(this.querySelectorAll('template[data-variant-image]'));
        this.imageContainer = this.querySelector('[data-image-container]');
        this.imageContainerForm = this.querySelector('[data-image-format-container]');
        this.currentVariantInput = this.variants.find(variant => variant.checked);
        this.currentVariantId = this.form?.elements['id']?.value;
        this.priceUpdate = this.querySelector('[data-price-update]');
        this.priceFormatUpdate = this.querySelector('[data-price-format-update]');

        this.addEventListener('change', this.handleFormChange.bind(this));

        this.form?.addEventListener('submit', (e) => {
            e.preventDefault();
            this.addToCart().catch(err => console.error('Add to cart error', err));
        });

        this.form_format?.addEventListener('submit', (e) => {
            e.preventDefault();
            this.addToCart('format').catch(err => console.error('Add to cart error', err));
        });

        this.nextBtn?.addEventListener('click', (e) => {
            this.classList.add('hide-format-elements');
        });

        this.backBtn?.addEventListener('click', (e) => {
            this.classList.remove('hide-format-elements');
        });

        if (this.formatElements) {
            this.formatElements.forEach((el) => {
                el.addEventListener('click', () => {
                    this.handleFormatSelection(el);
                });
            });
        }
    }

    handleFormatSelection(selectedElement = 'empty') {
        const purchaseType = this.getAttribute('purchase-type');
        const formatPriceTemplate = document.createElement('template');

        if (!selectedElement || selectedElement === 'empty') {
            selectedElement = Array.from(this.formatElements).find(el => el.classList.contains('selected'));
        }
        if (!selectedElement) return;

        this.formatElements.forEach((el) => {
            el.classList.remove('selected');
        });

        selectedElement.classList.add('selected');

        let price = selectedElement.getAttribute('data-one-time-price');
        let subscriptionPrice = selectedElement.getAttribute('data-subscription-price');
        let sellingPlanId = selectedElement.getAttribute('data-selling-plan-id');

        const formatPlanInput = this.form_format?.querySelector('.format-single-variant__input-plan');
        if (purchaseType === 'subscription' && sellingPlanId) {
            formatPlanInput?.setAttribute('value', sellingPlanId);
        } else {
            formatPlanInput?.setAttribute('value', '');
        }

        if (subscriptionPrice === '' || purchaseType === 'one-time') {
            formatPriceTemplate.innerHTML = `
				<span>${ price }</span>
			`;
        } else {
            formatPriceTemplate.innerHTML = `
				<span>${ subscriptionPrice }</span>
				<s>${ price }</s>
			`;
        }

        this.priceFormatUpdate?.replaceChildren(formatPriceTemplate.content);
    }

    handleFormChange(e) {
        const target = e.target;

        if (target.name === 'id') {
            this.currentVariantInput = target;
            this.currentVariantId = target.value;
            if (this.oneTimeSwitch) {
                this.oneTimeSwitch.value = this.oneTimeSwitch.checked
                    ? (target.dataset.sellingPlanId || '')
                    : '';
            }

            this.updateImage(this.currentVariantId);
            this.updatePrices(
                this.currentVariantInput.dataset.oneTimePrice,
                this.oneTimeSwitch?.checked ? this.currentVariantInput.dataset.subscriptionPrice : ''
            );
        }

        if (target.name === 'selling_plan') {
            if (this.oneTimeSwitch) {
                this.oneTimeSwitch.value = target.checked
                    ? (this.currentVariantInput?.dataset.sellingPlanId || '')
                    : '';
            }

            if (target.checked) {
                this.setAttribute('purchase-type', 'subscription');
                this.updatePrices(
                    this.currentVariantInput?.dataset.oneTimePrice,
                    this.currentVariantInput?.dataset.subscriptionPrice
                );
            } else {
                this.setAttribute('purchase-type', 'one-time');
                this.updatePrices(
                    this.currentVariantInput?.dataset.oneTimePrice
                );
            }

            this.handleFormatSelection();
        }

        if (this.savedValue) {
            const selectedInput = this.querySelector(".product-buy-variants__input:checked");
            this.savedValue.textContent = selectedInput?.getAttribute('data-save-amount') || '';
        }
    }

    async addToCart(type) {
        let formData;
        let form = null;
        if (type === 'format') {
            if (!this.form_format) return;
            formData = new FormData(this.form_format);
            form = this.form_format;
        } else {
            if (!this.form) return;
            formData = new FormData(this.form);
            form = this.form;
        }


        const properties = {};
        for (const [k, v] of formData.entries()) {
            const m = k.match(/^properties\[(.+?)\]$/);
            if (m) properties[m[1]] = v;
        }

        const mainItem = {
            id: Number(formData.get('id')),
            quantity: Number(formData.get('quantity') || 1)
        };
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) mainItem.selling_plan = Number(sellingPlan);
        if (Object.keys(properties).length) mainItem.properties = properties;

        const cartRes = await fetch('/cart.js', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            credentials: 'same-origin'
        });
        if (!cartRes.ok) throw new Error('Failed to fetch cart');
        const cart = await cartRes.json();

        const existingGiftIds = cart.items
            .filter(item => item.properties && item.properties._gift === 'true')
            .map(item => item.variant_id);

        const gifts = [];
        form.querySelectorAll('[data-gift-id]').forEach(el => {
            const id = Number(el.dataset.giftId);
            if (!id) return;
            if (!existingGiftIds.includes(id)) {
                gifts.push({
                    id: id,
                    quantity: 1,
                    properties: { _gift: 'true' }
                });
            }
        });

        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body: JSON.stringify({ items: [mainItem, ...gifts] }),
            credentials: 'same-origin'
        });

        if (!res.ok) {
            throw new Error(await res.text());
        }

        this.closest('modal-dialog')?.hide();

        if(this.getAttribute("process-to-checkout") === "true") {
            window.location.href = '/checkout';
        } else {
            document.dispatchEvent(new CustomEvent('cart::request-render'));
            document.dispatchEvent(new CustomEvent('cart::open'));
        }
    }

    updateImage(variantId) {
        if (!this.variantImages) return;

		const image = this.variantImages.find(image => image.dataset.variantImage === variantId);

		if (!image) return;

		this.imageContainer.replaceChildren(image.content.cloneNode(true));
    }

    updatePrices(oneTimePrice, subscriptionPrice = '') {
        const priceTemplate = document.createElement('template');

        if (subscriptionPrice === '') {
            priceTemplate.innerHTML = `
				<span class="visually-hidden visually-hidden--inline">${ this.getAttribute('locale-regular-price') }</span>
				<span>${ oneTimePrice }</span>
			`;
        } else {
            priceTemplate.innerHTML = `
				<span class="visually-hidden visually-hidden--inline">${ this.getAttribute('locale-sale-price') }</span>
				<span>${ subscriptionPrice }</span>
				<span class="visually-hidden visually-hidden--inline">${ this.getAttribute('locale-regular-price') }</span>
				<s>${ oneTimePrice }</s>
			`;
        }

        this.priceUpdate?.replaceChildren(priceTemplate.content);
    }

    setPurchaseType(type, { animate = false } = {}) {
        const isSubscription = type === 'subscription';

        if (!animate) {
            this.classList.add('no-purchase-transition');
        }

        if (this.oneTimeSwitch) {
            this.oneTimeSwitch.checked = isSubscription;
            this.oneTimeSwitch.value = isSubscription
                ? (this.currentVariantInput?.dataset.sellingPlanId || '')
                : '';
        }

        this.setAttribute('purchase-type', isSubscription ? 'subscription' : 'one-time');

        if (isSubscription) {
            this.updatePrices(
                this.currentVariantInput?.dataset.oneTimePrice,
                this.currentVariantInput?.dataset.subscriptionPrice
            );
        } else {
            this.updatePrices(this.currentVariantInput?.dataset.oneTimePrice);
        }

        this.handleFormatSelection();

        if (this.savedValue) {
            const selectedInput = this.querySelector('.product-buy-variants__input:checked');
            this.savedValue.textContent = isSubscription
                ? (selectedInput?.getAttribute('data-save-amount') || '')
                : '';
        }

        if (!animate) {
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    this.classList.remove('no-purchase-transition');
                });
            });
        }
    }

    resetToDefault() {
        this.setPurchaseType('subscription', { animate: false });
    }
}

customElements.define('product-subscriptions', ProductSubscriptions);

function getProductPopupModal(button) {
    const modalSelector = button.getAttribute('data-modal')
        || button.closest('modal-opener')?.getAttribute('data-modal');

    return modalSelector ? document.querySelector(modalSelector) : null;
}

function resetProductPopupModal(modal) {
    if (!modal) return;

    modal.classList.remove('one-time--view');
    modal.querySelector('product-subscriptions')?.resetToDefault();
}

function prepareProductPopupModal(modal, mode = 'subscription') {
    if (!modal) return;

    const subscriptions = modal.querySelector('product-subscriptions');

    if (mode === 'one-time') {
        subscriptions?.setPurchaseType('one-time', { animate: false });
        modal.classList.add('one-time--view');
        return;
    }

    resetProductPopupModal(modal);
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.buy-box__one-time-popup-button[data-modal]').forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();

            const modal = getProductPopupModal(button);
            prepareProductPopupModal(modal, 'one-time');
            modal?.show(button);
        });
    });

    document.querySelectorAll('.custom-buy-box__block modal-opener button').forEach((button) => {
        button.addEventListener('click', () => {
            prepareProductPopupModal(getProductPopupModal(button), 'subscription');
        }, true);
    });

    document.body.addEventListener('modalClosed', () => {
        requestAnimationFrame(() => {
            document.querySelectorAll('modal-dialog.product-popup-modal').forEach((modal) => {
                if (modal.hasAttribute('open')) return;
                resetProductPopupModal(modal);
            });
        });
    });
});
